const MatchStatus = [
    "NOT_START",
    "STARTED",
    "POSTPONED",
    "LOST",
    "WON"
];

export default MatchStatus;
